"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgLaneClosed(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 0 16 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M16.524 10.427l1.491 1.581v9h-3v-9l1.509-1.581zM9 3v18H6V3h3zm9.657 0l1.414 1.414-2.121 2.121 2.121 2.122-1.414 1.414-2.122-2.121-2.12 2.121L13 8.657l2.12-2.122L13 4.415 14.414 3l2.121 2.121L18.657 3z" })));
}
exports.default = tombacIcon_1.default('LaneClosed')(SvgLaneClosed);
//# sourceMappingURL=LaneClosed.js.map